export default __webpack_public_path__ + "static/scooter-e14443b94bebcb84e08e8f89b3bac7a2.png";